import React from 'react';
import { motion } from 'framer-motion';

// ═══════════════════════════════════════════════════════════════════
// PATH CARD - Individual service selection card
// ═══════════════════════════════════════════════════════════════════

const PathCard = ({ path, isSelected, onClick, index }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, delay: index * 0.1 }}
      whileHover={{ y: -4, transition: { duration: 0.2 } }}
      onClick={() => onClick(path.id)}
      className={`
        relative p-6 bg-white/5 backdrop-blur-sm rounded-xl cursor-pointer
        transition-all duration-300 border-2
        ${isSelected
          ? `border-${path.color}-500 shadow-2xl scale-105 bg-${path.color}-500/10`
          : 'border-white/10 hover:border-white/30 hover:bg-white/10'
        }
      `}
      style={{
        borderColor: isSelected ? path.colorHex : undefined,
        backgroundColor: isSelected ? `${path.colorHex}10` : undefined
      }}
    >
      {/* Icon */}
      <div className="text-4xl mb-4">{path.icon}</div>

      {/* Title */}
      <h3 className="text-xl font-semibold text-white mb-2">
        {path.title}
      </h3>

      {/* Description */}
      <p className="text-sm text-white/60 leading-relaxed">
        {path.description}
      </p>

      {/* Hover effect overlay */}
      {!isSelected && (
        <div
          className="absolute inset-0 rounded-xl opacity-0 hover:opacity-100 transition-opacity duration-300 pointer-events-none"
          style={{
            background: `linear-gradient(135deg, ${path.colorHex}10 0%, transparent 100%)`
          }}
        />
      )}

      {/* Selected indicator */}
      {isSelected && (
        <motion.div
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          className="absolute top-4 right-4"
        >
          <svg
            className="w-6 h-6"
            style={{ color: path.colorHex }}
            fill="currentColor"
            viewBox="0 0 20 20"
          >
            <path
              fillRule="evenodd"
              d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
              clipRule="evenodd"
            />
          </svg>
        </motion.div>
      )}

      {/* Pulse animation for selected state */}
      {isSelected && (
        <motion.div
          className="absolute inset-0 rounded-xl pointer-events-none"
          style={{
            border: `2px solid ${path.colorHex}`,
            opacity: 0.5
          }}
          animate={{
            scale: [1, 1.02, 1],
            opacity: [0.5, 0.2, 0.5]
          }}
          transition={{
            duration: 2,
            repeat: Infinity,
            ease: "easeInOut"
          }}
        />
      )}
    </motion.div>
  );
};

export default PathCard;